<template>
<v-window v-model="window" vertical touchless >
  <v-window-item >
    <v-card flat >
      <!-- <v-card-title class='subheading' >
        <strong><v-icon>receipt</v-icon> {{invoice.title}}</strong>
        <v-spacer></v-spacer>
        <v-btn v-if='withClose' icon @click='$emit("close")' ><v-icon>close</v-icon></v-btn>
      </v-card-title> -->
      <v-list three-line dark >
        <invoice-list-item v-if='invoice' :invoice='invoice' ></invoice-list-item>
      </v-list>
      <!-- <v-alert :value='true' color='warning' class='ma-0' >
        This invoice might generate quite a big file which may have issues sending.
        If you prefer, you can choose to send as a link rather than attaching the pdf.
      </v-alert> -->
      <!-- <pre v-text='client' /> -->
      <v-card-text>
        <v-subheader class='pa-0 overline'>Send to client
          <v-spacer />
          <v-chip @click='showCustomMessage=!showCustomMessage' small flat >Add custom message</v-chip>
        </v-subheader>
        <v-textarea v-if='showCustomMessage' outline class='caption' rows=2
          v-model='customMessage'
          label='Custom message'
          hint='Include a custom message in your email' />
        <v-btn style="float:right;margin-top:2px;" outline
          v-if='whatsapplink'
          :href='whatsapplink' target='_blank'
          color='green' dark small >
          Send via WhatsApp
          <v-icon class='ml-1' small >open_in_new</v-icon>
        </v-btn>
        <v-checkbox
          label="Send as SMS" class='ma-0'
          v-model="sendAsSMS"
          :disabled='!hasPhoneNumber'
          :hint='sendAsSMSHint' persistent-hint light></v-checkbox>


        <v-checkbox
          label="Send to email" class='ma-0 mt-2'
          :hint="sendToCustomerHint"
          :disabled='hasValidEmail === false'
          persistent-hint
          v-model="sendToCustomer" light></v-checkbox>

        <v-divider ></v-divider>
        <v-subheader class='pa-0 ma-0 overline' >Send to me</v-subheader>
        <v-checkbox
          label="Send to me" class='ma-0'
          v-model="sendToMe"
          :hint='sendToMeHint' persistent-hint light></v-checkbox>
        <vuex-loader :request-id='sendSMSReqId' ></vuex-loader>

        <!-- prepend-icon="search"
          :prepend-icon-cb="() => (showMedicalAidPicker=true)" -->
        <v-text-field class='mt-2'
          v-model='freeFormEmail' clearable
          type='email'
          label='Send to email'
          hint='Type the email address you would like to send this invoice to'
          :rules="[rules.email]" ></v-text-field>

        <!--<v-checkbox
          label="Send to person responsible for account"
          hint="We'll send it to their email address: .." v-model="sendToCustomer" light></v-checkbox>
        <v-btn small flat >
          <v-icon>add</v-icon>
          Add more emails</v-btn> -->

        <div class='mt-2' v-if='recipientsExist' transition="slide-y-transition" >
          <v-subheader class='pa-0' >Sending to</v-subheader>
          <v-chip v-for='email in emailList' :key='email' small >
            <v-avatar color='teal white--text' ><v-icon small dark>email</v-icon></v-avatar>
            {{email}}
          </v-chip>
          <v-chip v-if='sendAsSMS' small >
            <v-avatar color='teal white--text' ><v-icon small dark>chat</v-icon></v-avatar>
            {{normalizedClient.phone_number}}
          </v-chip>
        </div>
      </v-card-text>
      <v-card-actions>
          <v-btn v-if='withClose' @click='$emit("close")' flat >Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn flat
            v-if='relationshipId'
            @click='refreshContact'
            :loading='requests.contact.loading' >Reload contact info</v-btn>
          <v-btn
            :loading='loading'
            color='primary'
            @click='send'
            :disabled="!recipientsExist" >Send &nbsp;
            <v-icon>send</v-icon>
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-window-item>
  <v-window-item>
    <v-card flat>
      <v-card-text class='text-xs-center' >
        <template v-if='loading' >
          <v-progress-circular width='2' color='amber' size='36' indeterminate ></v-progress-circular>
          <div class='mt-3' >Sending</div>
        </template>
        <v-alert type='warning' :value='failedMessages && failedMessages.length > 0' >
          Some messages failed to send
        </v-alert>
        <v-list v-if='messageIdsToWatch && messageIdsToWatch.length > 0' dense subheader >
          <v-subheader>Sent messages</v-subheader>
          <communication-watcher
            v-for='messageId in messageIdsToWatch'
            :key='messageId'
            :message-id='messageId' >
          </communication-watcher >
        </v-list>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click='$emit("close");window=0;' text flat >Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-window-item>
  <!-- <v-btn @click='window--' >prev</v-btn> <v-btn @click='window++' >next</v-btn> -->
</v-window>

</template>

<script>
import axios from 'axios'
import CommunicationWatcher from '@/components/communications/CommunicationWatcher'
import InvoiceListItem from '@/components/invoice/InvoiceListItem'
export default {
  name: 'SendInvoice',
  components: {CommunicationWatcher, InvoiceListItem},
  props: {
    invoice: { type: Object, default: () => { return {} } },
    client: { type: Object, default: () => { return {client: {}} } },
    withClose: { type: Boolean, default: true }
  },
  data () {
    return {
      window: 1,
      loading: false,
      showCustomMessage: false,
      customMessage: null,
      messageIdsToWatch: [],
      sendAsSMS: false,
      sendToMe: false,
      sendToCustomer: false,
      showMedicalAidPicker: false,
      selectedMedicalAid: null,
      requestStatus: 0,
      successMessage: false,
      sendSMSReqId: 'send-invoice-sms-request',
      freeFormEmail: null,
      failedMessages: [],
      requests: {
        contact: {
          resource: 'ag.spaces.relationships'
        }
      },
      response: {
        messages: [
          {
            ok: true,
            response: {
              id: 81341,
              preferred_transport: 'email',
              recipient_emails: ['info@38.co.za', 'christo@appointmentguru.co']
            }
          },
          {
            ok: true,
            response: {
              id: 81342,
              preferred_transport: 'sms',
              recipient_phone_number: ['+27832566533']
            }
          }
        ]
      },
      rules: {
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Please provide a valid email address.'
        }
      }
    }
  },
  mounted () {
    if (this.clientId && this.clientId > 0) {
      let client = this.setClientFromId(this.clientId)
      if (client !== -1) { this.client = client }
    }
    // this.failedMessages.push(this.$store.getters.getCommunication('81356'))
    // this.window = 1
  },
  methods: {
    reset () {
      this.window = 0
      this.sendToCustomer = false
      this.sendAsSMS = false
      this.sendToMe = false
      this.freeFormEmail = ''
      this.customMessage = null
      this.messageIdsToWatch = []
    },
    refreshContact () {
      this.requests.contact.resourceId = this.relationshipId
      this.$request('get', this.requests.contact)
    },
    send () {
      let baseurl = process.env.INVOICEGURU_API_ROOT
      let url = `${baseurl}/invoices/${this.invoice.id}/send2/`
      let data = {
        to_email: this.emails
      }
      if (this.customMessage) {
        data['custom_message'] = this.customMessage
      }
      this.loading = true
      this.messageIdsToWatch = []
      this.failedMessages = []
      this.window = 1
      let token = this.$store.getters.token
      let headers = {
        'authorization': `bearer ${token}`
      }
      this.requestStatus = 'sending'
      this.successMessage = false
      let options = {
        headers: headers
      }
      if (this.sendAsSMS &&
          this.client &&
          this.normalizedClient &&
          this.normalizedClient.phone_number) {
        data['to_phone'] = this.normalizedClient.phone_number
      }
      axios.post(url, data, options)
        .then((response) => {
          this.requestStatus = 'sent'
          this.$emit('sent', this.invoice)
          this.successMessage = `Sent ✓`
          this.loading = false

          this.response = response
          let communications = this.getObjectPath(this.response, 'data.messages', [])
          communications.forEach((comm) => {
            if (comm.ok) {
              this.messageIdsToWatch.push(comm.response.id)
              this.$store.commit('addCommunication', comm.response)
            } else {
              this.failedMessages.push(comm.response)
            }
          })
        })
        .catch((err) => {
          this.response = err
          this.requestStatus = 'error'
          this.errorMessage = 'Unable to send message. Please try again'
          this.loading = true
          console.log(err)
        })
    }
  },
  watch: {
    selectedMedicalAid () {
      this.freeFormEmail = this.selectedMedicalAid.email
      this.showMedicalAidPicker = false
    },
    invoice: {
      immediate: true,
      handler () {
        this.reset()
      }
    },
    refreshContactRequestStatus () {
      if (this.requests.contact.status === 200) {
        let cli = this.getObjectPath(this.requests, 'contact.result')
        if (cli) { this.$emit('update:client', cli.client) }
      }
    }
  },
  computed: {
    emailList () {
      let emails = []
      if (this.sendToMe && this.me) {
        emails.push(this.me.email)
      }
      if (this.sendToCustomer &&
          this.client &&
          this.normalizedClient) {
        emails.push(this.normalizedClient.email)
      }
      if (this.freeFormEmail && this.rules.email(this.freeFormEmail) === true) {
        emails.push(this.freeFormEmail)
      }
      return emails
    },
    hasPhoneNumber () {
      return this.getObjectPath(this.normalizedClient, 'phone_number')
    },
    hasValidEmail () {
      if (this.normalizedClient) {
        return this.isRealEmail(this.normalizedClient.email)
      }
      return false
    },
    whatsapplink () {
      if (this.normalizedClient) {
        if (this.normalizedClient.phone_number) {
          let number = this.normalizedClient.phone_number.replace('+', '')
          let msg = `Hi ${this.normalizedClient.first_name}%0AHere's your invoice:%0A${this.invoiceUrl}%0AThanks!`
          return `https://wa.me/${number}?text=${msg}`
        }
      }
      return false
    },
    emails () {
      let emails = this.emailList
      return emails.join(',')
    },
    invoiceUrl () {
      if (this.invoice && this.invoice.id) {
        return this.$invoiceguru.baseUrl + '/invoice/' + this.invoice.id + '/?key=' + this.invoice.password
      }
    },
    me () {
      return this.$store.getters.me
    },
    recipientsExist () {
      let emailsExist = this.emails && this.emails.length > 3
      return (emailsExist || this.sendAsSMS)
    },
    sendToMeHint () {
      if (this.me) {
        return `(${this.me.email})`
      }
    },
    sendAsSMSHint () {
      if (this.hasPhoneNumber) {
        return `(${this.normalizedClient.phone_number})`
      } else {
        return 'No phone number for this client'
      }
    },
    sendToCustomerHint () {
      if (this.hasValidEmail) {
        return `(${this.normalizedClient.email})`
      } else {
        return 'No valid email address found for this client'
      }
    },
    relationshipId () {
      let relId = null
      relId = this.getObjectPath(this.invoice, 'relationship_id')
      if (!relId) {
        let userId = this.getObjectPath(this.invoice, 'customer_id')
        if (userId) {
          let rel = this.getRelationByClientId(userId)
          if (rel) { relId = rel.id }
        }
      }
      return relId
    },
    refreshContactRequestStatus () {
      return this.requests.contact.status
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// SendInvoice.vue?20d70627